import api from './config';

export const getDashboardStats = async () => {
  const response = await api.get('/dashboard');
  return response.data;
};

export const getRecentActivity = async (limit = 10) => {
  const response = await api.get(`/dashboard/recent-activity?limit=${limit}`);
  return response.data;
};
